import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { trackGTMEvent, useTrackCalendarBooking, useTrackClickedLeadFormSubmit } from "@air/analytics";
import { FormikField } from "@air/formik-field";
import { Button } from "@air/primitive-button";
import { Input } from "@air/primitive-input";
import { Modal, ModalCloseButton, ModalDescription, ModalTitle } from "@air/primitive-modal";
import { Formik } from "formik";
import Head from "next/head";
import { object, string } from "yup";
import Form from "~/components/Form";
import { FormikSingleSelect } from "~/components/Formik/FormikSingleSelect";
import { Routes } from "~/constants/routes";
const validationSchema = object({
    firstName: string().default("").required("First name is required"),
    lastName: string().default("").required("Last name is required"),
    email: string().email().test("Please enter a business email", "Please enter a business email", (value)=>{
        var _value_toLowerCase;
        return !(value === null || value === void 0 ? void 0 : (_value_toLowerCase = value.toLowerCase()) === null || _value_toLowerCase === void 0 ? void 0 : _value_toLowerCase.match(/[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](aol.com|comcast.net|gmail.com|gmail.co|gmail.to|gmx.com|hotmail.com|icloud.com|live.com|mac.com|mail.ck|mail.com|mailbird.com|me.com|msn.com|mymail.com|outlook.com|protonmail.com|postbox.com|rocketmail.com|sbcglobal.net|taskmonk.ai|test.com|thunderbird.com|turtlewig.com|zoho.com|yahoo.com|yandex.mail)/g));
    }).test("Please enter a personal business email", "Please enter a personal business email", (value)=>{
        var _value_toLowerCase;
        return !(value === null || value === void 0 ? void 0 : (_value_toLowerCase = value.toLowerCase()) === null || _value_toLowerCase === void 0 ? void 0 : _value_toLowerCase.match(/(info|hello)[@].*/g));
    }).required("Email address is required").default(""),
    company_size: string().default("").required("Company Size is required"),
    role: string().default("").required("Role is required"),
    industry: string().default("").required("Industry is required")
});
export const ChilipiperModal = (param)=>{
    let { onClose, uiLocation } = param;
    const { trackCalendarBooking } = useTrackCalendarBooking();
    const { trackClickedLeadFormSubmit } = useTrackClickedLeadFormSubmit();
    return /*#__PURE__*/ _jsxs(Modal, {
        className: "flex flex-col gap-4",
        dangerouslyBypassFocusLock: true,
        dangerouslyBypassScrollLock: true,
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx("script", {
                    src: "https://js.na.chilipiper.com/marketing.js",
                    type: "text/javascript",
                    async: true
                }, "chilipiper")
            }),
            /*#__PURE__*/ _jsxs("header", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(ModalTitle, {
                                children: "Let's talk"
                            }),
                            /*#__PURE__*/ _jsx(ModalCloseButton, {
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalDescription, {
                        children: "Schedule a free demo today. One of our experts will show you how Air works."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                initialValues: validationSchema.cast(undefined),
                onSubmit: (values, param)=>{
                    let { setSubmitting, resetForm } = param;
                    trackClickedLeadFormSubmit({
                        email: values.email,
                        ui_location: uiLocation
                    });
                    const url = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname);
                    trackGTMEvent({
                        event: "Lead Form Submit",
                        eventProps: {
                            label: "lead form submit",
                            category: "enterprise",
                            ...values
                        }
                    });
                    window.ChiliPiper.submit("air-inc", "router-11-17-2021", {
                        lead: {
                            ...values,
                            leadsource: "Web Form - App",
                            leadsourceurl: url
                        },
                        map: true,
                        onSuccess: ()=>{
                            trackCalendarBooking();
                            trackGTMEvent({
                                event: "Calendar Booking",
                                eventProps: {
                                    label: "calendar booking",
                                    category: "enterprise",
                                    leadsource: "Web Form - App",
                                    leadsourceurl: url
                                }
                            });
                            setSubmitting(false);
                            resetForm();
                        }
                    });
                },
                validationSchema: validationSchema,
                children: /*#__PURE__*/ _jsxs(Form, {
                    className: "flex flex-col gap-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-4 md:flex-row",
                            children: [
                                /*#__PURE__*/ _jsx(FormikField, {
                                    className: "w-full",
                                    component: /*#__PURE__*/ _jsx(Input, {
                                        autoComplete: "given-name",
                                        "data-1p-ignore": true,
                                        placeholder: "First name",
                                        required: true,
                                        size: "large",
                                        type: "text"
                                    }),
                                    id: "firstName",
                                    label: "First name",
                                    name: "firstName"
                                }),
                                /*#__PURE__*/ _jsx(FormikField, {
                                    className: "w-full",
                                    component: /*#__PURE__*/ _jsx(Input, {
                                        autoComplete: "family-name",
                                        "data-1p-ignore": true,
                                        placeholder: "Last name",
                                        required: true,
                                        size: "large",
                                        type: "text"
                                    }),
                                    id: "firstName",
                                    label: "Last name",
                                    name: "lastName"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(FormikField, {
                            className: "w-full",
                            component: /*#__PURE__*/ _jsx(Input, {
                                autoComplete: "email",
                                "data-1p-ignore": true,
                                placeholder: "Business email",
                                required: true,
                                size: "large",
                                type: "email"
                            }),
                            id: "email",
                            label: "Business email",
                            name: "email"
                        }),
                        /*#__PURE__*/ _jsx(FormikSingleSelect, {
                            label: "Company size *",
                            name: "company_size",
                            options: [
                                {
                                    label: "1-10",
                                    value: "1-10"
                                },
                                {
                                    label: "11-50",
                                    value: "11-50"
                                },
                                {
                                    label: "51-100",
                                    value: "51-100"
                                },
                                {
                                    label: "101-500",
                                    value: "101-500"
                                },
                                {
                                    label: "501-1000",
                                    value: "501-1000"
                                },
                                {
                                    label: "1001+",
                                    value: "1001+"
                                }
                            ],
                            placeholder: "Company size",
                            size: "large"
                        }),
                        /*#__PURE__*/ _jsx(FormikSingleSelect, {
                            label: "Your role *",
                            name: "role",
                            options: [
                                {
                                    label: "Marketing",
                                    value: "Marketing"
                                },
                                {
                                    label: "Creative",
                                    value: "Creative"
                                },
                                {
                                    label: "Operations",
                                    value: "Operations"
                                },
                                {
                                    label: "Executive Leadership",
                                    value: "Executive Leadership"
                                },
                                {
                                    label: "Account / Project Management ",
                                    value: "Account / Project Management "
                                },
                                {
                                    label: "Other",
                                    value: "Other"
                                }
                            ],
                            placeholder: "Your role",
                            size: "large"
                        }),
                        /*#__PURE__*/ _jsx(FormikSingleSelect, {
                            label: "Industry *",
                            name: "industry",
                            options: [
                                {
                                    label: "E-commerce / Direct to Consumer",
                                    value: "E-commerce / Direct to Consumer"
                                },
                                {
                                    label: "Agency",
                                    value: "Agency"
                                },
                                {
                                    label: "Education",
                                    value: "Education"
                                },
                                {
                                    label: "Sports and Athletics",
                                    value: "Sports and Athletics"
                                },
                                {
                                    label: "Non-Profit ",
                                    value: "Non-Profit "
                                },
                                {
                                    label: "Media and Entertainment",
                                    value: "Media and Entertainment"
                                },
                                {
                                    label: "Other",
                                    value: "Other"
                                }
                            ],
                            placeholder: "Industry",
                            size: "large"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            appearance: "filled",
                            color: "blue",
                            size: "large",
                            type: "submit",
                            children: "Submit"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "text-center text-14 text-grey-11",
                children: [
                    "By submitting the form, you agree to our ",
                    /*#__PURE__*/ _jsx("a", {
                        href: Routes.marketing.terms,
                        children: "Terms of Service"
                    }),
                    " and acknowledge our ",
                    /*#__PURE__*/ _jsx("a", {
                        href: Routes.marketing.privacy,
                        children: "Privacy Policy"
                    }),
                    "."
                ]
            })
        ]
    });
};
